import { getUserMuid } from '@meprism/shared/src/services/AuthenticationService';
import { getAdAttributes } from './helpers';

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

export const logCustomMetapixelEvent = async (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  try {
    const muid = await getUserMuid();
    const adAttributes = getAdAttributes();
     
    const payload = {
      ...(eventParams || {}),
      ...adAttributes,      
      ...(muid ? { "external_id": muid } : {})
    };

    if (typeof window !== "undefined" && typeof window.fbq !== "undefined") {
      window.fbq("trackCustom", eventName, payload);
    }
  } catch (error) {
    console.error("Error logging Metapixel event:", error);
  }
};